<template>
  <div class="d-flex overflow-hidden mw-100">
    <iframe class="iframe border-0" ref="frame" :srcdoc="iframeContent" :style="{ width: this.options.width }" />
  </div>
</template>

<script>
/* eslint-disable no-useless-escape */
import WidgetMixin from './Mixin.js'

export default {
  name: 'FacebookCommentsWidget',
  mixins: [WidgetMixin],
  data() {
    return {
      iframeContent: null,
    }
  },
  watch: {
    options: {
      handler: function({ href, postsToShow, width }) {
        this.iframeContent = this.getFacebookCode({ href, postsToShow, width })
      },
      deep: true,
    },
  },
  methods: {
    getFacebookCode({ href, postsToShow, width }) {
      return `<div id="fb-root"></div>
              <script
                async
                defer
                crossorigin="anonymous"
                src="https://connect.facebook.net/pt_BR/sdk.js#xfbml=1&version=v7.0"
                nonce="BwTwbmQJ">
              <\/script>

              <div
                style="margin: 0 auto"
                class="fb-comments"
                data-href="${href}"
                data-numposts="${postsToShow}" data-width="${width}">
              </div>`
    },
  },
  mounted() {
    this.iframeContent = this.getFacebookCode({
      href: this.options.href,
      postsToShow: this.options.postsToShow,
      width: this.options.width,
    })
  },
}
</script>

<style lang="scss" scoped>
.iframe {
  pointer-events: none;
  margin: 0 auto;
}
</style>
